// eslint-disable-next-line import/no-cycle
import { IRequestErrorServerResponse, RequestError } from 'Api';
import {
  SERVER_GENERAL_ERROR_MESSAGE,
  SERVER_GENERAL_ERROR_MESSAGE2,
} from 'Config/general-error-message';
import { Auth0Error } from 'auth0-js';
import { AuthError, IAuthLoginErrorMessage } from 'Auth';
import { BaseFormModelErrorHandler } from './BaseFormModelErrorHandler';

export class BaseAuthFormModelErrorHandler extends BaseFormModelErrorHandler {
  getErrorMessageByServerResponse(rawError: RequestError & Auth0Error): string {
    // Do not show error when user close tab with popup
    if (rawError?.original === 'User closed the popup window') return '';
    const apiError = rawError?.data as IRequestErrorServerResponse;
    const originalError = rawError?.original?.response?.body;
    const error = apiError || originalError || rawError;
    if (error === undefined) return SERVER_GENERAL_ERROR_MESSAGE;
    // ignore code `access_denied` as error because it's general error code on reject after login
    // but still it's code for wrong password, so check if is the case by description text
    if (error.code && (error.code !== 'access_denied' || (error as Auth0Error).description === 'Wrong email or password.')) {
      const formattedError = AuthError.getAuthErrorByCode(error.code);
      if (formattedError) return formattedError;
    }
    if (typeof (error as IAuthLoginErrorMessage)?.friendly_message === 'string') {
      return (error as IAuthLoginErrorMessage).friendly_message || '';
    }
    if (error.message) return error.message;
    if (typeof (error as IAuthLoginErrorMessage)?.description === 'string') {
      return (error as IAuthLoginErrorMessage).description || '';
    }
    if (typeof error.error === 'string') return error.error;
    return SERVER_GENERAL_ERROR_MESSAGE2;
  }

  getNormalizedError(error: RequestError & Auth0Error) {
    const errorMessage = this.getErrorMessageByServerResponse(error);
    const normalizedError = new RequestError(errorMessage, (error as RequestError)?.response || {}, (error as RequestError)?.data || {});
    normalizedError.handled = true;
    return normalizedError;
  }
}
